import { useEffect } from 'react';
import { atomWithStorage } from '@teetsh/app/src/utils/atomWithStorage';
import { useAtom } from 'jotai';
import useClassrooms from '@teetsh/app/src/containers/App/context/ClassroomsContext/useClassrooms';

interface EDTDisplayConfig {
  displayedClassroomsIds: string[];
}

const displayConfigAtom = atomWithStorage<Record<string, EDTDisplayConfig>>(
  'edtDisplayConfig',
  {},
);

export function useEDTDisplayConfig(edtId: string) {
  const classrooms = useClassrooms();
  const [displayConfig, setDisplayConfig] = useAtom(displayConfigAtom);

  useEffect(() => {
    if (!displayConfig[edtId]) {
      setDisplayConfig({
        ...displayConfig,
        [edtId]: {
          displayedClassroomsIds: classrooms.map(c => c.id),
        },
      });
    }
  }, [edtId, classrooms.map(c => c.id).join('')]);

  return {
    displayedClassroomsIds: displayConfig[edtId]?.displayedClassroomsIds || [],
    setDisplayedClassroomsIds: (classroomsIds: string[] = []) => {
      setDisplayConfig({
        ...displayConfig,
        [edtId]: {
          displayedClassroomsIds: classroomsIds,
        },
      });
    },
  };
}
